/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ESensorDbSensorTypes} from "../../../constants/globalVariables";

const sensorLidarHeaderTitle = "Lidar Database"
const getLidarLandingEndpoint = "/HttpTriggerSensors?req=get&type=lidar-landing"
const addLidarEndpoint = `/HttpTriggerSensors?req=add&type=${ESensorDbSensorTypes.LIDAR}`

const errorMessagesTitle = 'Error & Warning Messages:'
const fileProcessingMessagesTitle = 'File Processing Messages:'

const deleteLidarTempFileEndpoint = "/HttpTriggerSensors?req=delete&type=lidar-temp-file"
const addLidarConfigEndpoint = "/HttpTriggerSensors?req=add&type=lidar-config"
const deleteLidarConfigEndpoint = "/HttpTriggerSensors?req=delete&type=lidar-config"
const getLidarDetailsEndpoint = "/HttpTriggerSensors?req=get&type=lidar-details"
const getLidarPlotEndpoint = "/HttpTriggerSensors?req=get&type=lidar-plot"
const uploadFileLidarEndpoint = `/HttpTriggerSensors?req=upload-file&type=${ESensorDbSensorTypes.LIDAR}`

export interface Lidar {
  baseline: any
  id: string
  type: string
  version: string
  dateCreated: string
  plotData: any
  configurations: any
  owner: string
  isPublicConfig: string
  lidarType: string
  supplier: string
  component: string
  componentVersion: string
  detectionDegradation: number
  maxInstrumentedRange: number
  azimuthFOV: number
  elevationFOV: number
  txPowerHot: number
  wavelength: number
  numTxRxChannels: number
  modulationScheme: number
  totalFOVScanTime: number
  reflectivityImprovement: number
  pointsFrames: string
}

export {
  sensorLidarHeaderTitle,
  getLidarLandingEndpoint,
  addLidarEndpoint,
  errorMessagesTitle,
  fileProcessingMessagesTitle,
  deleteLidarTempFileEndpoint ,
  addLidarConfigEndpoint,
  deleteLidarConfigEndpoint,
  getLidarDetailsEndpoint,
  getLidarPlotEndpoint,
  uploadFileLidarEndpoint
}